import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, BrandingSettingsDialogueHandler } from './types';
import UpdatePaylinkCpmtext from './BrandingSettingsContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type PaylinkDialogueProps = {
  handleDialogue: DialogueHandler<BrandingSettingsDialogueHandler>;
};

type FC = FunctionComponent<PaylinkDialogueProps>;

const BrandingSettingsDialogue: FC = ({ handleDialogue }: PaylinkDialogueProps) => {
  const { showSuccessAlert, showErrorAlert, error } = useContext(UpdatePaylinkCpmtext);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.BrandingSettings.Dialog' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          buttonWidth="210px"
          subTitle={`${error}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'success' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          buttonWidth="210px"
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'save', state: 'success' }),
          }}
        />
      </div>
    ),
    [showSuccessAlert, showErrorAlert, error],
  );
};

export default BrandingSettingsDialogue;
